<template>
  <div class="home" :style="{width: homeWidth}">
    <template v-if="token">
      <!-- 头部 -->
      <div class="fd-r jc-sb" :class="scrollTop !== 0 ? 'QKrU5e' : ''" style="height: 56px;width: 100%;padding: 0 8px ;position: sticky;top: 0;background: white;z-index: 999; transition: box-shadow .2s ease-in-out;">
        <div class="fd-r" style="flex:1">
          <img style="width: 25px;" src="@/assets/icon-left.png" alt="left">
          <div style="color: #0070c9;">{{$t('i_top_back')}}</div>
        </div>
        <template v-if="scrollTop >= 150">
          <img style="width: 30px;flex-shrink: 0;border-radius: 20%;" :src="info.image" :alt="info.title">
          <div class="fd-r jc-fe" style="flex:1">
            <div class="fd-c ai-fe" style="margin-right: 8px;">
              <div style="font-size: 8px;color: #808388;">{{$t('i_app')}}</div>
              <div style="font-size: 8px;color: #808388;">{{$t('i_purchases')}}</div>
            </div>
            <div style="background: #0070c9;padding: 5px 18px;font-size: 14px;color: white;width: fit-content;border-radius: 50px;font-weight: bold;" @click="toInstall">{{$t('i_install')}}</div>
          </div>
        </template>
      </div>
      <div style="margin: auto;padding: 0 20px;">
        <!-- 应用图片名称 -->
        <div class="fd-r ai-s" style="margin-top: 24px;">
          <img style="border-radius:20%;width: 38%;" :src="info.image" :alt="info.title">
          <div class="fd-c jc-sb" style="margin-left: 5%;flex: 1;">
            <div class="fd-c">
              <div style="font-size:22px;line-height: 2rem;color: inherit;font-weight: bold;">{{info.title}}</div>
              <div style="color: rgba(60,60,67,.6)">{{info.issue}}</div>
            </div>
            <div class="fd-r jc-sb">
              <div style="background: #0070c9;padding: 4px 24px;color: white;width: fit-content;border-radius: 50px;font-weight: bold;" @click="toInstall">GET</div>
              <div class="fd-c" style="margin-left: -30px;">
                <div style="font-size: 8px;color: #808388;">In-App</div>
                <div style="font-size: 8px;color: #808388;">Purchases</div>
              </div>
              <img style="width: 28px;" src="@/assets/icon-share2.png" alt="share">
            </div>
          </div>
        </div>
        <!-- 应用基础信息，评分/年龄限制/排行榜等 -->
        <div class="fd-r" style="margin: 24px 0;padding: 12px 0;overflow-x:auto;border-top: 1px solid #d6d6d6;">
          <div class="fd-c ai-c wVqUob" style="width: 100px;flex-shrink: 0;">
            <div style="font-size: 12px;color: #808388;white-space: nowrap;line-height: 1.5em;">{{info.offer}}K {{$t('i_base_ratings')}}</div>
            <div style="font-weight: bold;font-size: 22px;margin-top: 10px;color: #808388;">{{info.score}}</div>
            <div class="fd-r">
              <i class="google-material-icons">★</i>
              <i class="google-material-icons">★</i>
              <i class="google-material-icons">★</i>
              <i class="google-material-icons">★</i>
              <i class="google-material-icons">★</i>
            </div>
          </div>
          <div class="fd-c ai-c wVqUob" style="width: 100px;flex-shrink: 0;">
            <div style="font-size: 12px;color: #808388;white-space: nowrap;line-height: 1.5em;">{{$t('i_base_age')}}</div>
            <div style="font-weight: bold;font-size: 22px;margin-top: 10px;color: #808388;">{{info.stint}}+</div>
            <div style="font-size: 12px;color: #808388;line-height: 1.5em;">{{$t('i_base_year')}}</div>
          </div>
          <div class="fd-c ai-c wVqUob" style="width: 100px;flex-shrink: 0;">
            <div style="font-size: 12px;color: #808388;white-space: nowrap;line-height: 1.5em;">{{$t('i_base_chart')}}</div>
            <div style="font-weight: bold;font-size: 22px;margin-top: 10px;color: #808388;">No.1</div>
            <div style="font-size: 12px;color: #808388;line-height: 1.5em;">{{$t('i_base_entertainment')}}</div>
          </div>
          <div class="fd-c ai-c wVqUob" style="width: 100px;flex-shrink: 0;position: relative;">
            <div style="font-size: 12px;color: #808388;white-space: nowrap;line-height: 1.5em;">{{$t('i_base_developer')}}</div>
            <img style="margin-top: 5px;width: 30px;display: block;" src="@/assets/icon-developer.png" alt="developer">
            <div style="font-size: 12px;color: #808388;line-height: 1.5em;width: 80px;white-space: nowrap;overflow: hidden;">{{info.title}} Co., Ltd</div>
          </div>
          <div class="fd-c ai-c wVqUob" style="width: 100px;flex-shrink: 0;">
            <div style="font-size: 12px;color: #808388;white-space: nowrap;line-height: 1.5em;">{{$t('i_base_language')}}</div>
            <div style="font-weight: bold;font-size: 22px;margin-top: 10px;color: #808388;">{{useLanguage(info.lingo, 'simple')}}</div>
            <div style="font-size: 12px;color: #808388;line-height: 1.5em;">+ 1 {{$t('i_base_more')}}</div>
          </div>
          <div class="fd-c ai-c wVqUob" style="width: 100px;flex-shrink: 0;">
            <div style="font-size: 12px;color: #808388;white-space: nowrap;line-height: 1.5em;">{{$t('i_base_size')}}</div>
            <div style="font-weight: bold;font-size: 22px;margin-top: 10px;color: #808388;">{{info.store}}</div>
            <div style="font-size: 12px;color: #808388;line-height: 1.5em;">MB</div>
          </div>
        </div>
        <!-- 应用内案例图片 -->
        <div class="fd-r" style="overflow-x: auto;flex-wrap: nowrap;gap: 12px;padding: 3px;">
          <img v-for="(item,index) in info.album" :key="index" style="width: 200px;;border-width: 0;border-radius: 20px;cursor: pointer;" :src="item" @click="priview(item)" :alt="index">
        </div>
        <!-- 关于此应用 -->
        <div style="border-top: 1px solid #d6d6d6;margin-top: 24px;padding: 24px 0;">
          <div v-html="info.brief"></div>
          <div class="fd-c" style="margin-top: 24px;">
            <div style="color: #0070c9;">{{info.title}} Co., Ltd</div>
            <div style="color: #808388;
      font-size: 12px;
      margin-top: 4px;">{{$t('i_intro_developer')}}</div>
          </div>
        </div>
        <!-- 评分及评论 -->
        <div class="fd-r jc-sb" style="border-top: 1px solid #d6d6d6;padding-top: 8px;">
          <div style="font-size:22px;line-height: 2rem;color: inherit;font-weight: bold;">{{$t('i_r&r')}}</div>
          <div style="color: #0070c9">{{$t('i_r&r_all')}}</div>
        </div>
        <div class="fd-r ai-fs" style="gap: 24px;padding-top: 4px;padding-bottom: 16px;">
          <div class="fd-c ai-c">
            <div style="font-size: 3rem;color: #202124;font-weight: 900;">{{info.score}}</div>
            <div style="color: #808388;">{{$t('i_r&r_total')}}</div>
          </div>
          <div class="fd-c" style="flex: 1;">
            <div class="fd-r">
              <div class="fd-r" style="margin-right: 12px;font-size:8px;color: #5F6368;">
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span>
              </div>
              <div style="flex: 1;background: rgb(232,234,237);height: 5px;border-radius: 9999px;">
                <div style="width: 90%;background: #808388;height: 5px;border-radius: 9999px;"></div>
              </div>
            </div>
            <div class="fd-r">
              <div class="fd-r" style="margin-right: 12px;margin-left: 8px;font-size:8px;color: #5F6368;">
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span></div>
              <div style="flex: 1;background: rgb(232,234,237);height: 5px;border-radius: 9999px;">
                <div style="width: 4%;background: #808388;height: 5px;border-radius: 9999px;"></div>
              </div>
            </div>
            <div class="fd-r">
              <div class="fd-r" style="margin-right: 12px;margin-left: 16px;font-size:8px;color: #5F6368;">
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span>
              </div>
              <div style="flex: 1;background: rgb(232,234,237);height: 5px;border-radius: 9999px;">
                <div style="width: 3%;background: #808388;height: 5px;border-radius: 9999px;"></div>
              </div>
            </div>
            <div class="fd-r">
              <div class="fd-r" style="margin-right: 12px;margin-left: 24px;font-size:8px;color: #5F6368;">
                <span style="color:#808388">★</span>
                <span style="color:#808388">★</span>
              </div>
              <div style="flex: 1;background: rgb(232,234,237);height: 5px;border-radius: 9999px;">
                <div style="width: 2%;background: #808388;height: 5px;border-radius: 9999px;"></div>
              </div>
            </div>
            <div class="fd-r">
              <div class="fd-r" style="margin-right: 12px;margin-left: 32px;font-size:8px;color: #5F6368;">
                <span style="color:#808388">★</span>
              </div>
              <div style="flex: 1;background: rgb(232,234,237);height: 5px;border-radius: 9999px;">
                <div style="width: 1%;background: #808388;height: 5px;border-radius: 9999px;"></div>
              </div>
            </div>
            <div style="color: #808388;text-align: right;margin-top: 8px;">{{info.offer}}K {{$t('i_r&r_ratings')}}</div>
          </div>
        </div>
        <!-- 评论内容 -->
        <template v-if="info.forum">
          <div class="fd-r" style="overflow-x: auto;flex-wrap: nowrap;gap: 12px">
            <div v-for="(item,index) in info.forum" :key="index" style="padding: 13px 16px 16px;flex-shrink: 0;width: 93%;height: 200px;background-color: #f1f1f1;border-radius: 6px;align-self: start;">
              <div class="fd-r jc-sb ai-fe">
                <div class="fd-c">
                  <div style="font-weight: bold;width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.intel}}</div>
                  <div class="star-container2">
                    <div v-for="(star, index) in 5" :key="index" class="star">
                      <span class="star-filled" :style="{ width: getStarFillWidth(index, item.score) + '%' }">★</span>
                      <span style="color:rgb(241,243,244);font-size: 14px;">★</span>
                    </div>
                  </div>
                </div>
                <div class="fd-c ai-fe" style="/*padding-bottom: 4px;*/">
                  <div style="font-size: 14px;color: #808388">{{toRelativeTime(item.issue)}}</div>
                  <div style="font-size: 14px;color: #808388;margin-top: 4px;">{{item.title}}</div>
                </div>
              </div>
              <div style="font-size: 14px;margin-top: 12px; display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 6;overflow: hidden;" v-html="item.intel"></div>
            </div>
          </div>
        </template>
        <!-- 新功能 -->
        <template v-if="info.renew">
          <div>
            <div class="fd-r jc-sb" style="border-top: 1px solid #d6d6d6;padding-top: 8px;margin-top: 24px;">
              <div style="font-size:22px;line-height: 2rem;color: inherit;font-weight: bold;">What's New</div>
              <div style="color: #0070c9">Version History</div>
            </div>
            <div class="fd-r jc-sb">
              <div style="font-size: 14px;color: #808388;">Version 2.2.2</div>
              <div style="font-size: 14px;color: #808388;">1d ago</div>
            </div>
            <div style="margin-top: 12px;" v-html="info.renew"></div>
          </div>
        </template>
        <!-- 信息 -->
        <div>
          <div class="fd-r jc-sb" style="border-top: 1px solid #d6d6d6;padding-top: 8px;margin-top: 24px;">
            <div style="font-size:22px;line-height: 2rem;color: inherit;font-weight: bold;">{{$t('i_info')}}</div>
          </div>
          <div class="fd-r jc-sb" style="border-bottom: 1px solid #d6d6d6;padding: 14px 0;font-size: 14px;">
            <div style="color: #808388">{{$t('i_info_provider')}}</div>
            <div>{{info.title}} Co., Ltd</div>
          </div>
          <div class="fd-r jc-sb" style="border-bottom: 1px solid #d6d6d6;padding: 14px 0;font-size: 14px;">
            <div style="color: #808388">{{$t('i_info_size')}}</div>
            <div>{{info.store}} MB</div>
          </div>
          <div class="fd-r jc-sb" style="border-bottom: 1px solid #d6d6d6;padding: 14px 0;font-size: 14px;">
            <div style="color: #808388">{{$t('i_info_category')}}</div>
            <div>Entertainment</div>
          </div>
          <div class="fd-r jc-sb" style="border-bottom: 1px solid #d6d6d6;padding: 14px 0;font-size: 14px;">
            <div style="color: #808388">{{$t('i_info_compatibility')}}</div>
            <div>Works on this iPhone</div>
          </div>
          <div class="fd-r jc-sb" style="border-bottom: 1px solid #d6d6d6;padding: 14px 0;font-size: 14px;">
            <div style="color: #808388">{{$t('i_info_languages')}}</div>
            <div>{{useLanguage(info.lingo, 'entire')}}</div>
          </div>
          <div class="fd-r jc-sb" style="border-bottom: 1px solid #d6d6d6;padding: 14px 0;font-size: 14px;">
            <div style="color: #808388">{{$t('i_info_age')}}</div>
            <div>{{info.stint}}+</div>
          </div>
          <div class="fd-r jc-sb" style="border-bottom: 1px solid #d6d6d6;padding: 14px 0;font-size: 14px;">
            <div style="color: #808388">{{$t('i_info_purchases')}}</div>
            <div>Yes</div>
          </div>
          <div class="fd-r jc-sb" style="border-bottom: 1px solid #d6d6d6;padding: 14px 0;font-size: 14px;">
            <div style="color: #808388">{{$t('i_info_copyright')}}</div>
            <div>@ {{info.title}}</div>
          </div>
          <div class="fd-r jc-sb" style="padding: 12px 0;font-size: 14px;">
            <div style="color: #0070c9">{{$t('i_info_privacy')}}</div>
            <img style="width: 26px;" src="@/assets/icon-hand.png" alt="hand">
          </div>
        </div>
        <!-- 你可能还喜欢 -->
        <template v-if="info.guess">
          <div>
            <div class="fd-r jc-sb" style="border-top: 1px solid #d6d6d6;padding-top: 8px;margin-top: 24px;">
              <div style="font-size:22px;line-height: 2rem;color: inherit;font-weight: bold;">You Might Also Like</div>
              <div style="color: #0070c9">See All</div>
            </div>
          </div>
          <div class="fd-r" v-for="(item,index) in info.guess" :key="index" style="padding-top: 10px;">
            <img style="width: 60px;border-radius: 8px;" :src="item.img" :alt="item.name">
            <div class="fd-r jc-sb" style="margin-left: 8px;flex:1;padding: 10px 0 ;">
              <div class="fd-c">
                <div>{{item.name}}</div>
                <div style="font-size: 12px;color: #808388;">{{item.brief}}</div>
              </div>
              <div class="fd-c ai-c">
                <div style="background: #eee;padding: 4px 24px;color: #0070c9;width: fit-content;border-radius: 50px;font-weight: bold;">GET</div>
                <div style="font-size: 10px;color: #808388;margin-top: 4px;">In-App Purchases</div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- 底部菜单 -->
      <div class="fd-r jc-sa" style="position: sticky;bottom: 0;left: 0;right: 0;border-top: 1px solid rgb(218, 220, 224);background: #f8f8f8;padding-bottom: 24px;padding-top: 4px;margin-top: 30px;">
        <div class="fd-c ai-c">
          <img style="width: 33px;" src="@/assets/icon-today.png" alt="today">
          <div style="font-size: 10px;color: #707077;">{{$t('i_bot_today')}}</div>
        </div>
        <div class="fd-c ai-c">
          <img style="width: 33px;" src="@/assets/icon-rock.png" alt="games">
          <div style="font-size: 10px;color: #707077;">{{$t('i_bot_games')}}</div>
        </div>
        <div class="fd-c ai-c">
          <img style="width: 33px;" src="@/assets/icon-app.png" alt="apps">
          <div style="font-size: 10px;color: #0070c9;">{{$t('i_bot_apps')}}</div>
        </div>
        <div class="fd-c ai-c">
          <img style="width: 33px;" src="@/assets/icon-search2.png" alt="search">
          <div style="font-size: 10px;color: #707077;">{{$t('i_bot_search')}}</div>
        </div>
      </div>
      <!-- 安装帮助 -->
      <div v-if="helpShow" class="fd-r jc-sa" style="position: fixed; top: 0;left: 0;bottom:0;right: 0; height: 100vh;width: 100%;max-width: 500px;margin: auto; background: rgba(0, 0, 0, .8);z-index: 99999">
        <img style="width: 80%;border-radius: 8px;" :src="require(`@/assets/help-${helpIndex}.png`)" alt="help">
        <div class="fd-r jc-sb" style="position: fixed;top: 0;left: 0;bottom:0;right: 0;padding: 0 24px;">
          <img v-if="helpIndex === 2" style="width:48px;height: 48px;" src="@/assets/icon-left-fill.png" @click="helpIndex=1" alt="left">
          <div v-else style="width: 48px;height: 48px;"></div>
          <img v-if="helpIndex === 1" style="width:48px;height: 48px;" src="@/assets/icon-right-fill.png" @click="helpIndex=2" alt="right">
          <div v-else style="width: 48px;height: 48px;"></div>
        </div>
        <img style="width:36px;height: 36px;position: fixed ;right:24px;top: 24px;" src="@/assets/icon-error.png" @click="helpShow=false" alt="close">
      </div>
      <!-- 提示弹窗 -->
      <div v-if="toastShow" style="position: fixed;left: 0;right: 0;top: 0;bottom: 0;margin: auto;width: fit-content;height: fit-content;padding: 6px 12px;background: rgba(0, 0, 0, .7);color:white;border-radius: 4px;">{{toastValue}}</div>
    </template>
    <template v-else>
      <div class="fd-r jc-c" style="margin-bottom: 40px;">
        <img style="width: 80%;height: auto;margin-top: 48px;" src="@/assets/404.png" alt="404">
      </div>
      <div class="fd-r jc-c" style="font-size: 24px;font-weight: bold;line-height: 40px;color: #1482f0;margin-bottom: 20px;">404 Error!</div>
      <div class="fd-r jc-c" style="font-size: 16px;line-height: 24px;color: #222;font-weight: bold;margin-bottom: 10px;">Page not found!</div>
      <div class="fd-r jc-c" style="font-size: 12px;line-height: 22px;color: grey;text-align: center;padding: 0 40px;margin-bottom: 30px;">
        Sorry, the page you are looking for does not exist. Try checking the URL for errors and pressing the refresh
        button on your browser or try to find something else in our app.
      </div>
    </template>
    <!-- 图片点击弹窗 -->
    <div v-if="viewShow" class="fd-r jc-c" style="position: fixed; top: 0;left: 0;bottom:0;right: 0; height: 100vh;width: 100%;max-width: 500px;margin: auto; background: rgba(0, 0, 0, .9);z-index: 99999">
      <img style="width: 90%;height: auto;border-radius: 8px;" :src="viewValue" :alt="info.title" @click="viewShow=false">
    </div>
  </div>
</template>

<script>
  import { apiConfig, apiDetail } from "@/api/index.js"
  export default {
    name: 'iosView',
    data() {
      return {
        homeWidth: 0, // 屏幕宽度
        scrollTop: 0, // 滚动高度
        viewShow: false, // 图片预览开关
        viewValue: "", // 图片预览地址
        helpShow: false, // 帮助预览开关
        helpIndex: 1, // 帮助图片索引
        toastShow: false, // 提示弹窗开关
        toastValue: "", // 提示弹窗文字
        token: "",
        config: {},
        info: {
          title: "ㅤ",
          issue: "ㅤ",
          image: require("@/assets/logo.png"),
          brief: "ㅤ",
          album: [],
          lingo: "en",
          score: "5.0",
          offer: "1",
          store: "1",
          stint: "3",
          renew: "",
          label: [],
          forum: [
            {
              photo: require("@/assets/logo.png"),
              title: 'Username',
              intel: "Comment Details",
              score: 5,
              issue: '2025-01-01',
              agree: 10
            },
            {
              photo: require("@/assets/logo.png"),
              title: 'Username',
              intel: "Comment Details",
              score: 5,
              issue: '2025-01-01',
              agree: 10
            }
          ],
          guess: [
            {
              img: require("@/assets/logo.png"),
              name: "Title",
              brief: "Brief"
            },
            {
              img: require("@/assets/logo.png"),
              name: "Title",
              brief: "Brief"
            }
          ]
        }
      }
    },
    mounted() {
      document.title = 'App Store';

      this.updateIcon();

      this.homeWidth = window.innerWidth + 'px'

      window.addEventListener('scroll', this.handleScroll);

      this.token = this.$route.query.config; // 获取应用参数

      if (this.isAndroid()) {
        this.$router.push({ path: '/android', query: { config: this.token } });return;
      }

      window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);

      if (this.token) {
        const url = `/json/${this.token}/manifest.json?version=` + Date.now()

        const link = document.querySelector('link[rel="manifest"]');
        if (link) {
          link.href = url;
        } else {
          const newLink = document.createElement('link');
          newLink.rel = 'manifest';
          newLink.href = url;
          document.head.appendChild(newLink);
        }

        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.register('/service_worker.js?config=' + this.token + '&version=' + Date.now()).then((registration) => {
            console.log('Service Worker Registration successful:', registration.scope);
          }).catch((error) => {
            console.error('Service Worker Registration failed: ', error);
          });
        } else {
          console.log('The current browser does not support Service Worker');
        }
      }

      // this.apiConfig(); // 获取全局配置

      this.apiDetail(); // 获取应用详情
    },
    methods: {
      updateIcon() {
        let favicon = document.querySelector('link[rel="icon"]');

        if (!favicon) {
          favicon = document.createElement('link');
          favicon.rel = 'icon';
          document.head.appendChild(favicon);
        }

        favicon.href = 'data:image/vnd.microsoft.icon;base64,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';
      },
      insertHead() {
        if (this.isIos()) {
          /*let oldType = document.querySelector('meta[name="apple-mobile-web-app-capable"]');

          if (oldType) {
            oldType.content = "yes";
          } else {
            const newType = document.createElement('meta');
            newType.name = "apple-mobile-web-app-capable";
            newType.content = "yes";
            document.head.appendChild(newType);
          }*/

          let oldName = document.querySelector('meta[name="apple-mobile-web-app-title"]');

          if (oldName) {
            oldName.content = this.info.title;
          } else {
            const newName = document.createElement('meta');
            newName.name = "apple-mobile-web-app-title";
            newName.content = this.info.title;
            document.head.appendChild(newName);
          }

          let oldLink = document.querySelector('link[rel="apple-touch-icon"]');

          if (oldLink) {
            oldLink.href = this.info.image;
          } else {
            const newLink = document.createElement('link');
            newLink.rel = "apple-touch-icon";
            newLink.href = this.info.image;
            document.head.appendChild(newLink);
          }
        }
      },
      handleBeforeInstallPrompt(e) {
        e.preventDefault()
        this.deferredPrompt = e
      },
      // 去安装
      toInstall() {
        if (this.isIos()) {
          if (this.isSafari()) {
            this.helpShow = true
          } else {
            this.toast('Please use Safari browser to open');
          }
        } else {
          this.toast('Your device is not an Apple device')
        }
      },
      // 评分星星颜色处理
      getStarFillWidth(index, totalScore) {
        const starIndex = index + 1;
        if (totalScore >= starIndex) {
          return 100;
        } else if (totalScore > starIndex - 1) {
          return (totalScore - (starIndex - 1)) * 100;
        }
        return 0;
      },
      // 核心转换函数
      toRelativeTime(dateStr) {
        const date = new Date(dateStr);

        // 处理无效日期
        if (isNaN(date.getTime())) {
          return '无效日期格式';
        }

        const now = new Date();
        const diffMs = now - date;

        // 计算时间差
        const diffSecs = Math.floor(diffMs / 1000);
        const diffMins = Math.floor(diffSecs / 60);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);
        const diffWeeks = Math.floor(diffDays / 7);
        const diffMonths = Math.floor(diffDays / 30);
        const diffYears = Math.floor(diffDays / 365);

        // 根据时间差返回不同格式
        if (diffSecs < 60) return 'just now';
        if (diffMins < 60) return `${diffMins}m ago`;
        if (diffHours < 24) return `${diffHours}h ago`;
        if (diffDays < 7) return `${diffDays}d ago`;
        if (diffWeeks < 4) return `${diffWeeks}w ago`;
        if (diffMonths < 12) return `${diffMonths}m ago`;

        return `${diffYears}y ago`;
      },
      // 提示
      toast(title) {
        this.toastValue = title
        this.toastShow = true
        setTimeout(() => {
          this.toastShow = false
        }, 1500)
      },
      useLanguage(lang, type) {
        let language = {
          'en': {
            'simple': 'EN',
            'entire': 'English'
          },
          'es': {
            'simple': 'ES',
            'entire': 'Spanish'
          },
          'hi': {
            'simple': 'HI',
            'entire': 'Hindi'
          },
          'ja': {
            'simple': 'JA',
            'entire': 'Japanese'
          },
          'ko': {
            'simple': 'KO',
            'entire': 'Korean'
          },
          'pt': {
            'simple': 'PT',
            'entire': 'Portuguese'
          },
          'th': {
            'simple': 'TH',
            'entire': 'Thai'
          },
          'vi': {
            'simple': 'VI',
            'entire': 'Vietnamese'
          }
        };

        return language[lang][type] ?? '';
      },
      // 判断苹果设备
      isIos() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
      },
      // 判断安卓设备
      isAndroid() {
        return /Android/.test(navigator.userAgent);
      },
      // 判断Safari浏览器
      isSafari() {
        return /iPhone|iPad|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent) && !/CriOS|Chrome/.test(navigator.userAgent)
      },
      handleScroll() {
        // 获取滚动条位置
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      },
      apiConfig() {
        apiConfig().then(res => {
          this.config = res.data
        })
      },
      apiDetail() {
        apiDetail({
          token: this.token
        }).then(res => {
          if (res.data.title !== undefined && res.data.title !== '') {
            this.info = {
              title: res.data.title ?? this.info.title,
              issue: res.data.issue ?? this.info.issue,
              image: res.data.image ?? this.info.image,
              brief: res.data.brief ? res.data.brief.replace(/\n/g, "<br/>") : this.info.brief,
              album: res.data.album ?? this.info.album,
              lingo: res.data.lingo ?? this.info.lingo,
              score: res.data.score ?? this.info.score,
              offer: res.data.offer ?? this.info.offer,
              store: res.data.store ?? this.info.store,
              stint: res.data.stint ?? this.info.stint,
              label: res.data.label ?? this.info.label,
              forum: res.data.forum ?? this.info.forum
            }

            this.$i18n.locale = this.info.lingo

            this.insertHead();
          } else {
            this.token = ""
          }
        })
      },
      // 查看图片
      priview(value) {
        this.viewValue = value
        this.viewShow = true
      }
    }
  }
</script>
<style scoped>
  .home {
    margin: auto;
    max-width: 500px;
    position: relative;
  }

  .google-material-icons {
    font-family: 'Google Material Icons';
    font-weight: normal;
    font-style: normal;
    color: #808388;
    font-size: 16px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }

  .wVqUob {
    position: relative;
  }

  .wVqUob:not(:first-child)::before {
    background-color: rgb(232, 234, 237);
    content: "";
    display: block;
    height: 36px;
    left: 0;
    position: absolute;
    top: calc(50% - 12px);
    width: 1px;
  }

  .star-container2 {
    display: flex;
    font-size: 10px;
    color: #ccc;
    gap: 1px;
  }

  .star {
    position: relative;
    width: 14px;
  }

  .star-filled {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 14px;
    overflow: hidden;
    color: orange;
  }

  .QKrU5e {
    background: #f8f8f8 !important;
  }
</style>
